import styles from './Loader.module.scss';

interface LoaderProps {
  mini?: boolean;
}

export const Loader = ({ mini = false }: LoaderProps) => {
  return <div className={mini ? styles.miniLoader : styles.loader}></div>;
};
